import { Fragment } from 'react';
import DataGrid from '@/components/elements/lists/DataGrid';
import { _t } from '@/locale';
import { CheckoutDetailsProduct } from '@/types/checkout';

type Props = {
  baseTranslationKey:
    | 'components.modules.checkout.CheckoutDetails'
    | 'components.modules.appointment.AppointmentDetailsSummary';
  products?: CheckoutDetailsProduct[];
};

const PaymentDetailsProductsList = ({ products, baseTranslationKey }: Props) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <>
      {products.map(({ name, price, discount }, key) => {
        return (
          <Fragment key={`fragment-${name}-${key}`}>
            <DataGrid.Row hasPaddingTop>
              <DataGrid.Cell
                title={name}
                type="default"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.product.name`)}
                truncate
              />
              <DataGrid.Cell
                title={discount ? <span className="text-fg_highlight">{discount}</span> : price}
                align="right"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.product.price`)}
                nowrap
              />
            </DataGrid.Row>
            <DataGrid.Row underline>
              <DataGrid.Cell
                title={
                  <span className="gap-sm flex flex-nowrap items-center">
                    <span className="text-nowrap">{_t('Product')}</span>
                  </span>
                }
                type="description"
              />
              {discount && (
                <DataGrid.Cell
                  title={<span className="text-fg_secondary line-through">{price}</span>}
                  type="description"
                  ariaLabel={_t(`${baseTranslationKey}.ariaLabel.product.price`)}
                  align="right"
                />
              )}
            </DataGrid.Row>
          </Fragment>
        );
      })}
    </>
  );
};

export default PaymentDetailsProductsList;
